/**
 * Given a minimum and maximum year, creates an array of options for a select
 * menu that contains all intervening years.
 * @param {number} min - The lowest year.
 * @param {number} max - The highest year.
 * @returns {Array} An array of options for the select menu.
 */
const getYearOptions = (min, max) => {
  const yearOptions = [];
  for (let i = min; i <= max; i += 1) {
    const stringifiedYear = i.toString();
    yearOptions.push({
      label: stringifiedYear,
      value: stringifiedYear,
    });
  }

  return yearOptions;
};

export default getYearOptions;
